import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import { routerMiddleware } from "react-router-redux";
import { createBrowserHistory } from "history";

import createRootReducer from "../_reducers";

const loggerMiddleware = createLogger();
export const history = createBrowserHistory();

export function configureStore(preloadedState:any) {
    const store = createStore(
        createRootReducer(),
        preloadedState,
        composeWithDevTools(
            applyMiddleware(
                routerMiddleware(history),
                thunkMiddleware,
                loggerMiddleware
        ))
    );

    return store;
}